// 120フォルダ内画像一括import
export const thumbnail120 = {
  "01": require("./01_thumbnail.png"),
  "02": require("./02_thumbnail.png"),
  "03": require("./03_thumbnail.png"),
  "04": require("./04_thumbnail.png"),
  "05": require("./05_thumbnail.png"),
  "06": require("./06_thumbnail.png"),
};

export const image120 = {
  "01": require("./01.png"),
  "02": require("./02.png"),
  "03": require("./03.png"),
  "04": require("./04.png"),
  "05": require("./05.png"),
  "06": require("./06.png"),
};
